import { ButtonHTMLAttributes, forwardRef, ReactNode } from "react";
import styles from "./SquareButton.module.scss";
import { LoadingIcon } from "@/frontend/shared/assets/icons";
import clsx from "clsx";

export type TSquareButtonProps = {
  children?: ReactNode;
  className?: string;
  isDisabled?: boolean;
  isSubmitting?: boolean;
  size?: "small" | "medium" | "large";
  variant?: "primary" | "secondary" | "tertiary";
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const SquareButton = forwardRef<HTMLButtonElement, TSquareButtonProps>(function (
  props: TSquareButtonProps,
  ref
) {
  const {
    children,
    className,
    isDisabled = false,
    isSubmitting = false,
    variant = "primary",
    size = "small",
    ...otherProps
  } = props;

  // Medium button size is deprecated - A
  // TODO: change all medium buttons to large
  const newSize = size === "medium" ? "large" : size;

  return (
    <button
      className={clsx(styles.btn, { [styles.disabled]: isDisabled, [styles.isSubmitting]: isSubmitting }, [
        className,
        styles[variant],
        styles[newSize]
      ])}
      disabled={isDisabled}
      ref={ref}
      {...otherProps}
    >
      {isSubmitting ? <LoadingIcon className={styles.loadingIcon} /> : children}
    </button>
  );
});
